export default __webpack_public_path__ + "static/media/postgresql-backup.61adc72e.svg";